import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { CategoryNavigation } from './categoryNavigation.component';
import {
  selectActiveCategory,
  selectActiveMainCategory,
  selectCategoriesHierarchy,
} from '../../reducers/news/news.selectors';
import { ArticleActions } from '../../reducers/news/news.redux';
import { selectMenuForm } from '../../reducers/menu/menu.selectors';

const mapStateToProps = createStructuredSelector({
  categories: selectCategoriesHierarchy,
  activeMainCategory: selectActiveMainCategory,
  activeCategory: selectActiveCategory,
  form: selectMenuForm,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchCategories: ArticleActions.fetchCategories,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CategoryNavigation);
